import React, {useState,cloneElement } from 'react';
import {
  List,
  TopToolbar,
  Datagrid,
  TextField,
  DateField,
  SelectInput,
  DeleteButton,
  EditButton,
  RefreshButton,
  ExportButton,
  ReferenceField,
  ShowButton,
  Filter,
  TextInput,
  GET_ONE,
  useTranslate,
  useResourceContext,
  useRecordContext
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import {
  getComplaintTypeChoices,
  getComplaintStatusChoices,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import Modal from "react-responsive-modal";
import moment from "moment";
import { getLocalStorageKey } from "../common/common";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from 'react-router-dom';

const ComplaintMangerFilter = (props) => (
  <Filter {...props}>
    <TextInput source="business_name"  />
    <TextInput source="business_sap_code"  />
    <TextInput source="complaint_number"  />
    <TextInput source="subcategory_name"  />
    {getComplaintTypeChoices().length > 0 && (
      <SelectInput
        source="complaint_type"
        choices={getComplaintTypeChoices()}
      />
    )}
    {getComplaintStatusChoices().length > 0 && (
      <SelectInput
        source="complaint_status"
        choices={getComplaintStatusChoices()}
      />
    )}
  </Filter>
);

const SubcategoryName = () => {
  const record = useRecordContext();
  return (
    <span>
      {record && record.subcategory_name ? `${record.subcategory_name}` : "-"}
    </span>
  );
};

const ResolutionField = ({ source }) => {
  const record = useRecordContext();
  if (record.complaint_created_at == record.updated_at) {
    return <span>-</span>;
  }
  return (
    <span>{moment(record.updated_at).format("MM/DD/YYYY, H:mm:ss a")}</span>
  );
};

// const topToolbarStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };

// const ListActions = ({ resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
//     return (
//         <TopToolbar>
//             {filters && cloneElement(filters, {
//                 resource,
//                 showFilter,
//                 displayedFilters,
//                 filterValues,
//                 context: 'button',
//             })}
//             <RefreshButton />
//             <ExportButton
//                 disabled={total === 0}
//                 resource={resource + '_csv'}
//                 sort={currentSort}
//                 filter={{ ...filterValues, ...permanentFilter }}
//                 exporter={exporter}
//                 maxResults={maxResults}
//             />
//         </TopToolbar>
//     )
// }

// const ListActions = (props) => {
//     const [modalShow, setModalShow] = React.useState(false);
//     const [modalMsg, setModalMsg] = React.useState('')
//     const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//     const csvResource = resource + '_csv'
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;

//     const callExport = (e) => {
//       e.preventDefault();
//       console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//       options.method = 'GET';
//       fetch(`${apiUrl}/${resource}_csv?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D`, options)
//         .then(res => {
//             return res.json();
//         }).then(jsonD => {
//           console.log('jsonD VVVVVVx===>', jsonD.data);
//           const msg = jsonD.data? jsonD.data[0].message : '';
//           setModalShow(true);
//           setModalMsg(msg);
//         });
//     }
//     const exporterModal = () => {
//       return ''
//     }

//     const onClose = () => {
//       setModalShow(false)
//     }
//     return (
//       <React.Fragment>
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <ExportButton
//           onClick={(e) => callExport(e)}
//           disabled={total === 0}
//           resource={csvResource}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={exporterModal}
//           maxResults={maxResults}
//           />
//         {
//           console.log('xxxx', csvResource)
//         }
//       </TopToolbar>
//       {
//             modalShow &&
//             <Modal open={modalShow} onClose={onClose} center>
//               <h3>{modalMsg}</h3>
//             </Modal>
//       }
//       </React.Fragment>
//     )
//   }

const ListActions =(props)=> {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     const [modalShow, setModalShow] = useState(false);
  //     const [modalMsg, setModalMsg] = useState("");
  //     const [customFilterUrl, setCustomFilterUrl] = useState('filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D');
  //   };
  // }
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
      const [modalMsg, setModalMsg] = useState("");
      const [customFilterUrl, setCustomFilterUrl] = useState(
        location.search
        );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log(
      "...",
      location.pathname,
      `${apiUrl}/${resource}_csv`
    );
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(
        `${apiUrl}/${resource}_csv?${_url[1]}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });
    } else {
      
      setCustomFilterUrl(location.search)
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });

      // this.setState(
      //   {
      //     customFilterUrl:
      //       'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
      //   },
      //   () => {
      //     fetch(
      //       `${apiUrl}/${props.resource}_csv?${customFilterUrl}`,
      //       options
      //     )
      //       .then((res) => {
      //         return res.json();
      //       })
      //       .then((jsonD) => {
      //         console.log("json= inside callback", jsonD.data);
      //         const msg = jsonD.data ? jsonD.data[0].message : "";
      //         Swal.fire({
      //           html: msg,
      //           icon: "success",
      //         });
      //         // this.setState({ modalShow: true});
      //         // this.setState({ modalMsg: msg});
      //       });
      //   }
      // );
    }
  };
  // exporterModal = () => {
  //   return "";
  // };

 const onClose = () => {
    // this.setState({ modalShow: false });
    setModalShow(false);
  };
  
    const {
      filterValues,
      total,
      maxResults,
      currentSort,
      exporter,
      permanentFilter,
      showFilter,
      displayedFilters,
      filters,
    } = props;
    const csvResource = resource + "_csv";
    return (
      <React.Fragment>
        <TopToolbar>
          {filters &&
            cloneElement(filters, {
              resource,
              showFilter,
              displayedFilters,
              filterValues,
              context: "button",
            })}
          <RefreshButton />
          {/* <ExportButton
            onClick={(e) => this.callExport(e)}
            disabled={total === 0}
            resource={csvResource}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
            exporter={this.exporterModal}
            maxResults={maxResults}
          /> */}
          <div>
            <button
              className="export-button"
              onClick={(e) => callExport(e)}
              disabled={total === 0}
              sort={currentSort}
              filter={{ ...filterValues, ...permanentFilter }}
            >
              {<GetAppIcon />}
              <span>Export</span>
            </button>
          </div>
        </TopToolbar>
        {modalShow && (
          <Modal open={modalShow} onClose={onClose} center>
            <h3>{modalMsg}</h3>
          </Modal>
        )}
      </React.Fragment>
    );
  
}

const ComplaintManagementsList =(props)=> {
  // state = {
  //     moodalShow: false,
  // }
  // exporter = (data) => {
  //     const msg = data[0].message;
  //     this.setState({
  //         moodalShow: true,
  //         modalMsg: msg,
  //     })
  // }

  // onClose = () => {
  //     this.setState({
  //         moodalShow: false,
  //     })
  // }


    const showReferenceNo = getLocalStorageKey("show_reference_no");
    const translate = useTranslate();

    return (
      <React.Fragment>
        <Scrollbars class="scroll-container">
          <List
            {...props}
            exporter={props.exporter}
            sort={{ field: "complaint_created_at", order: "DESC" }}
            filters={<ComplaintMangerFilter />}
            title={translate('resources.complaints.fields.contact_us')}
            actions={<ListActions permissions={props} />}
          >
            <Datagrid rowClick="show" bulkActionButtons={false}>
              <TextField source="business_name" />
              <TextField source="business_sap_code" />
              <ReferenceField
                source="user_id"
                reference="users"
                link="show"
                allowEmpty
              >
                <TextField source="first_name" />
              </ReferenceField>
              <TextField source="complaint_type"  />
              <TextField source="complaint_number"  />
              <TextField source="category_name"  />
              <SubcategoryName
                source="subcategory_name"
              />
              {showReferenceNo && showReferenceNo.show && (
                <TextField source="reference_number" />
              )}
              <TextField source="complaint_status"  />
              <DateField
                source="complaint_created_at"
                showTime={true}
              />
              <DateField
                source="updated_at"
                showTime={true}
              />
              {/* <ResolutionField source="updated_at" label="Resolution Timestamp" /> */}
              <ShowButton />
              <EditButton />
              <DeleteButton />
            </Datagrid>
          </List>
        </Scrollbars>
        {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
      </React.Fragment>
    );
  
}

export default ComplaintManagementsList;
